// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2NGJj","fileBtn":"File_fileBtn__tyeFL","closeBtn":"File_closeBtn__3jw_v","fileSelected":"File_fileSelected__3Jnju","disabled":"File_disabled__6Mz-E"};